module.exports = __webpack_public_path__ + "static/media/doyoung-6.jpeg";